export default function WorkshopTitle(props){
    return(
      <section className="section-sm bg-gray">
        <div className="container h2 text-dark font-secondary">
            {props.children}
        </div>
      </section>
    );
}
